<template>
  <van-popup :show="show" @update:show="$emit('update:show', $event)" :close-on-click-overlay="false"
    class="reward-dialog" round>
    <div class="reward-content">
      <!-- 顶部插图区域 -->
      <div class="reward-illustration">
        <!-- 牛头图片 -->
        <img :src="getAssetsFile('activity/niutous.png')" alt="Reward" class="reward-image">
      </div>

      <!-- 文字和按钮区域 -->
      <div class="reward-text color-[#6A6A6A]">
        <p class="reward-message color-[#6A6A6A]">
          {{ t('rewardDialog.congratulations') }}
        <div v-if="IS_DOUBLE_WALLET">
          <div v-if="props.amount.reward">
            <span class="reward-amount">{{ VITE_symbol }}{{ numberFormat(props.amount.reward, { minDecimals: 2 })
              }}</span>
          </div>
        </div>
        <div v-else>
          <!-- 根据 currency 字段判断显示 Cash 还是 Bonus -->
          <div v-if="props.amount.reward">
            <span class="reward-amount">
              {{ VITE_symbol }}{{ numberFormat(props.amount.reward, { minDecimals: 2 }) }} 
              ({{ props.amount.currency === 'BOUND' ? t('bonus') : t('cash') }})
            </span>
          </div>
          <!-- 兼容旧逻辑：如果没有 currency 字段，使用 rewardBound -->
          <div v-if="!props.amount.currency && props.amount.rewardBound">
            <span class="reward-amount">{{ numberFormat(props.amount.rewardBound, {
              minDecimals: 2
            }) }} ({{ t('bonus') }})</span>
          </div>
        </div>

        {{ t('rewardDialog.bonusChips') }}
        </p>
        <!-- 确认按钮 -->
        <div class="flex items-center justify-center">
          <div class="reward-button" @click="handleConfirm">
            {{ t('rewardDialog.confirm') }}
          </div>
        </div>
      </div>

    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { getAssetsFile } from '@/utils/pub-use'
import { useI18n } from 'vue-i18n'
import { numberFormat } from '@/utils/formatter'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const IS_DOUBLE_WALLET = import.meta.env.VITE_IS_DOUBLE_WALLET
const { t } = useI18n()

interface Props {
  show: boolean
  amount: {
    reward?: number;
    rewardBound?: number;
    currency?: string;    // 货币类型：BOUND（彩金）或 CASH（现金）
  }
}

interface Emits {
  (e: 'update:show', value: boolean): void
  (e: 'confirm'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const handleConfirm = () => {
  emit('update:show', false)
  emit('confirm')
}
</script>

<style scoped>
.reward-dialog {
  width: 80%;
  max-width: 320px;
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.reward-content {
  padding-bottom: 0;
  text-align: center;
  background: transparent;
  border-radius: 16px;
}

.reward-illustration {
  margin-bottom: 0;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px 16px 0 0;
  position: relative;
  overflow: hidden;
  background: transparent;
}

.reward-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 2;
  border-radius: 16px 16px 0 0;
}

.reward-text {
  margin-bottom: 0;
  margin-top: -10px;
  background: white;
  padding: 20px;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.reward-message {
  font-size: 16px;
  color: #6A6A6A;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 20px;
}

.reward-amount {
  color: #FF4444;
  font-weight: bold;
  font-size: 18px;
}

.reward-button {
  background: linear-gradient(180deg, #3CC35F 0%, #3A9857 100%);
  color: white;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  width: 35%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(19, 199, 105, 0.3);
}

.reward-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(19, 199, 105, 0.4);
}

.reward-button:active {
  transform: translateY(0);
}
</style>
